export default "__VITE_ASSET__BfxfyE$f__"